import request from '@/Utils/request.js';
// 获取所有考试地区
export function GetExamAreaList(params) {
  return request({
    url: '/api/ExamPublic/GetExamAreaList',
    method: 'get',
    params: params
  });
}

// 获取所有科目
export function GetMajorsList(params) {
  return request({
    url: '/api/ExamPublic/GetALLMajorsList',
    method: 'get',
    params: params
  });
}


// 获取所有等级
export function GetALLGradesList(params) {
  return request({
    url: '/api/ExamPublic/GetALLGradesList',
    method: 'get',
    params: params
  });
}

// 获取所有考试批次列表
export function GetAllExamBatchList(params) {
  return request({
    url: '/api/ExamPublic/GetALLExamBatchALLFeeList',
    method: 'get',
    params: params
  });
}

// 提交报名信息
export function ExamSignUp(data) {
  return request({
    url: '/api/Exam/ExamSignUp',
    method: 'post',
    data: data
  });
}

// 获取报名信息
export function GetExamFormInfo(params) {
  return request({
    url: '/api/Exam/GetExamFormInfo',
    method: 'get',
    params: params
  });
}

// 获取报名信息
export function UpdateExamForm(data) {
  return request({
    url: '/api/Exam/UpdateExamForm',
    method: 'post',
    data: data
  });
}

// 获取报名个人列表
export function GetMyExamFormList(params) {
  return request({
    url: '/api/Exam/GetMyExamFormList',
    method: 'get',
    params: params
  });
}

// 获取当前批次所有费用列表
export function GetExamBatchFeeList(params) {
  return request({
    url: '/api/ExamPublic/GetExamBatchFeeList',
    method: 'get',
    params: params
  });
}

// 创建准考证号
export function CreateExamNo(params) {
  return request({
    url: '/api/ExamPublic/CreateExamNo',
    method: 'post',
    params: params
  });
}


// 获取我的在线考试的报名信息
export function GetMyOnlineExamList(params) {
  return request({
    url: '/api/Exam/GetMyOnlineExamList',
    method: 'get',
    params: params
  });
}

// 获取考级曲目
export function ExamFromPatternList(params) {
  return request({
    url: '/api/Exam/ExamFromPatternList',
    method: 'get',
    params: params
  });
}
// 获取抽取考题
export function RandomQuestion(params) {
  return request({
    url: '/api/Exam/RandomQuestion',
    method: 'post',
    params: params
  });
}

// 获取答题记录
export function GetAnswerSheetList(params) {
  return request({
    url: '/api/Exam/GetAnswerSheetList',
    method: 'get',
    params: params
  });
}

// 创建答题记录
export function AddExamAnswerSheetInfo(params) {
  return request({
    url: '/api/Exam/AddExamAnswerSheetInfo',
    method: 'post',
    params: params
  });
}

// 提交答题答案
export function UpdateExamAnswerSheetInfo(data) {
  return request({
    url: '/api/Exam/UpdateExamAnswerSheetInfo',
    method: 'post',
    data: data
  });
}

// 获取题目列表
export function GetExamQuestionList(params) {
  return request({
    url: '/api/Exam/GetExamQuestionList',
    method: 'get',
    params: params
  });
}
// 获取考试批次列表（菜单）
export function GetALLExamBatchMenuList() {
  return request({
    url: '/api/ExamPublic/GetALLExamBatchMenuList',
    method: 'get'
  });
}

// 重置答题
export function ResetAnswerRecord(params) {
  return request({
    url: '/api/Exam/ResetAnswerRecord',
    method: 'post',
    params: params
  });
}

// 提交答题
export function SubAnswer(params) {
  return request({
    url: '/api/Exam/SubAnswer',
    method: 'post',
    params: params
  });
}

// 修改用户照片
export function UpdateExamFormPhoto(params) {
  return request({
    url: '/api/Exam/UpdateExamFormPhoto',
    method: 'post',
    params: params
  });
}

// 获取科目教材
export function GetExamTextBookList(params) {
  return request({
    url: '/api/ExamPublic/GetExamTextBookList',
    method: 'get',
    params: params
  });
}

// 选定教材
export function SelectTextBook(params) {
  return request({
    url: '/api/Exam/SelectTextBook',
    method: 'post',
    params: params
  });
}


// 查询准考证
export function FindExamFormInfo(params) {
  return request({
    url: '/api/Exam/FindExamFormInfo',
    method: 'post',
    params: params
  });
}

//查询成绩
export function ScoreQuery(params) {
  return request({
    url: '/api/Exam/ScoreQuery',
    method: 'get',
    params: params
  });
}

// 查看评语
export function ExaminerReviewInfo(params) {
  return request({
    url: '/api/Exam/ExaminerReviewInfo',
    method: 'get',
    params: params
  });
}

//查询省级成绩
export function OtherScoreQuery(params) {
  return request({
    url: '/api/Exam/OtherScoreQuery',
    method: 'get',
    params: params
  });
}

export function SetOfflineExamTracks(params, data) {
  return request({
    url: '/api/Exam/SetOfflineExamTracks',
    method: 'post',
    params: params,
    data: data
  });
}


